import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { FDPaper } from '@facet-wealth/design';

const useStyles = buildUseStyles('ViewSectionLayout', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 3),
  },
  header: {
  },
  content: {
    marginBottom: theme.spacing(4),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  textbox: {
    width: 'fit-content',
    borderRadius: theme.radius.md,
    color: theme.palette.facet.darkGray,
  },
}));

function ViewSectionLayout() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const {
    resource,
  } = useMetaLayoutContext();

  const [noteResource] = resource.attr('sectionData');

  return (
    <div className={classes.root}>
      <OnboardingPlannerViewSectionHeader
        className={classes.header}
        title={resource.attr('title')}
      />
      <Box className={classes.content}>
        <FDPaper appearance="outlined" padding={3}>
          <div className={classes.textbox}>
            <RichTextDisplay content={noteResource.attr('content')} />
          </div>
        </FDPaper>
      </Box>
    </div>
  );
}

export default ViewSectionLayout;
